import * as React from 'react';
import OrderHeader from '../Header/OrderHeader.js';

const Order = ({ children , footer , orderDate , orderNumber , shipmentStatus , paymentStatus , receiptUrl , shipmentTrackingUrl , onTraceOrder , onReorder , onOpenCancelReturnsModal , onCloseCancelReturnsModal , onDownloadReceiptClick , isCancelReturnsModalOpen , isPaid ,  })=>{
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(OrderHeader, {
        orderDate: orderDate,
        orderNumber: orderNumber,
        shipmentStatus: shipmentStatus,
        paymentStatus: paymentStatus,
        isPaid: isPaid,
        receiptUrl: receiptUrl,
        shipmentTrackingUrl: shipmentTrackingUrl,
        onTraceOrder: onTraceOrder,
        onReorder: onReorder,
        onOpenCancelReturnsModal: onOpenCancelReturnsModal,
        onCloseCancelReturnsModal: onCloseCancelReturnsModal,
        onDownloadReceiptClick: onDownloadReceiptClick,
        isCancelReturnsModalOpen: isCancelReturnsModalOpen,
        className: "order__header"
    }), children, footer && /*#__PURE__*/ React.createElement("div", {
        className: "order__footer"
    }, footer));
};
var Order$1 = Order;

export { Order, Order$1 as default };
//# sourceMappingURL=Order.js.map
